<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container">
      <a routerLink="/calculators" class="ph-hero__back">
        <i class="lni lni-arrow-left" aria-hidden="true"></i>
        {{ 'CALCULATORS.BACK' | translate }}
      </a>
      <h1 class="ph-hero__title">{{ 'CALCULATOR1.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'CALCULATOR1.TEXT' | translate }}</p>
    </div>
  </section>

  <section id="calculator" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-calc-layout">
        <form [formGroup]="formGroup" (ngSubmit)="calculate()" class="ph-calc-form-card ph-calc-form">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR1.PROPERTY_PRICE' | translate }}</mat-label>
            <input type="text" formControlName="propertyPrice" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR1.MONTHLY_RENT' | translate }}</mat-label>
            <input type="text" formControlName="montlyRent" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR1.YEARLY_EXPENSES' | translate }}</mat-label>
            <input type="text" formControlName="anualExpenses" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR1.OCCUPATION_RATE' | translate }}</mat-label>
            <input type="text" formControlName="occupationRate" matInput />
          </mat-form-field>
          <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="!formGroup.valid">
            {{ 'CALCULATOR1.COMPUTE' | translate }}
          </button>
        </form>

        <div class="ph-calc-results">
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-calculator"></i></div>
            <p class="ph-result-card__value">{{ grossRentalYield | number : '1.2-2' }}%</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR1.YIELD_GROSS' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR1.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-grow"></i></div>
            <p class="ph-result-card__value">{{ netRentalYield | number : '1.2-2' }}%</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR1.YIELD_NET' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR1.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-euro"></i></div>
            <p class="ph-result-card__value">{{ cashflow | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR1.FLOW_INCOME' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR1.YEARLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-alarm-clock"></i></div>
            <p class="ph-result-card__value">{{ paybackPeriod | number : '1.2-2' }} ani</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR1.PAYBACK_PERIOD' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR1.INVESTMENT' | translate }}</span>
          </article>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="c1-name">{{ 'HOME.NAME' | translate }}</label>
          <input id="c1-name" type="text" name="name" [(ngModel)]="contactItem.subject" required [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="c1-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input id="c1-email" type="email" name="email" [(ngModel)]="contactItem.email" required email [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="c1-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea id="c1-message" name="message" rows="4" [(ngModel)]="contactItem.content" required [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
